

















export default {
  name: "BaseButton",
  props: {
    viewType: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
